import moment from "moment";
import React from "react";
import ReactDOM from "react-dom";
import "./Countdown.css";
import { Box, Grid } from "@mui/material";
export default class Countdown extends React.Component {
  state = {
    days: undefined,
    hours: undefined,
    minutes: undefined,
    seconds: undefined,
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      const { timeTillDate, timeFormat } = this.props;
      const then = moment(timeTillDate, timeFormat);

      const now = moment();

      const countdown = moment(then - now);
      const days = countdown.format("D");
      const hours = countdown.format("HH");
      const minutes = countdown.format("mm");
      const seconds = countdown.format("ss");

      this.setState({ days, hours, minutes, seconds });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { days, hours, minutes, seconds } = this.state;
    const daysRadius = mapNumber(days, 30, 0, 0, 360);
    const hoursRadius = mapNumber(hours, 24, 0, 0, 360);
    const minutesRadius = mapNumber(minutes, 60, 0, 0, 360);
    const secondsRadius = mapNumber(seconds, 60, 0, 0, 360);

    if (!seconds) {
      return null;
    }

    return (
      <div>
        <div className="countdown-wrapper">
          <Box className="box" sx={{ flexGrow: 1 }}>
            <Grid container>
              <Grid className="cryptopanties" item xs={12} md={12} lg={12}>
                CRYPTOPANTIES
              </Grid>
              <Grid className="supporting" item xs={12} md={12} lg={12}>
                EMPOWERING WOMEN IN CRYPTO
              </Grid>
              <Grid className="count" item xs={12} md={12} lg={12}></Grid>
            </Grid>
          </Box>
          <div className="counter">
            {days && (
              <div className="countdown-item">
                <h3>{days}</h3>

                <h6>DAYS </h6>
              </div>
            )}
            <div className="colon">:</div>
            {hours && (
              <div className="countdown-item">
                <h3>{hours}</h3>
                <h6>HOURS </h6>
              </div>
            )}
            <div className="colon">:</div>
            {minutes && (
              <div className="countdown-item">
                <h3>{minutes}</h3>
                <h6>MINUTES </h6>
              </div>
            )}
            <div className="colon">:</div>
            {seconds && (
              <div className="countdown-item">
                <h3>{seconds}</h3>
                <h6>SECONDS</h6>
              </div>
            )}
          </div>

          <Box className="section1__box__btns" sx={{ flexGrow: 1 }}>
            <Grid container>
              <Grid className="section1__socials" item xs={12} md={12} lg={12}>
                {/* <Grid container>
                                <Grid item xs={12} md={12} lg={5.5}>
								<div className='section1__disc'>
                                            JOIN DISCORD

                                        </div>
                                </Grid>
								<Grid item xs={0} md={0} lg={1}></Grid>
                                <Grid item xs={12} md={12} lg={5.5}>
								<div className='section1__news'>
                                            NEWSLETTER

                                        </div>
                                </Grid>
                               
                      </Grid> */}
                <div className="section1__btns">
                  <div className="section1__disc">
                    <img src="./assets/Group 5.svg"></img>
                  </div>

                  <div className="section1__news">
                    <img src="./assets/Group 6.svg"></img>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    );
  }
}

// From stackoverflow: https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle
function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

function describeArc(x, y, radius, startAngle, endAngle) {
  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);

  var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  var d = [
    "M",
    start.x,
    start.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y,
  ].join(" ");

  return d;
}

// Stackoverflow: https://stackoverflow.com/questions/10756313/javascript-jquery-map-a-range-of-numbers-to-another-range-of-numbers
function mapNumber(number, in_min, in_max, out_min, out_max) {
  return (
    ((number - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
  );
}
